import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { HttpClient } from '@angular/common/http';
import { EnvironmentServices } from '../../services/evironment.service';

@Component({
    selector: 'correctionapp',
    templateUrl: '/templates/get/Correction/correction',
})
export class CorrectionComponent implements OnInit{
    public errstr = '';
    pid = 'CORRECTION';
    public modalRef: BsModalRef;
    @ViewChild('archiveusersessionmodal')
    private archiveUserSessionTemplateRef: TemplateRef<any>;
    @ViewChild('restoreusersessionmodal')
    private restoreUserSessionTemplateRef: TemplateRef<any>;
    @ViewChild('archivelogtablesmodal')
    private archiveLogTablesTemplateRef: TemplateRef<any>;
    @ViewChild('restorelogtablesmodal')
    private restoreLogTablesTemplateRef: TemplateRef<any>;
    @ViewChild('umbmodal')
    private umbmigrationTemplateRef: TemplateRef<any>;
    counter: number;
    userId: number;
    toDate: Date;
    userSessionIdThreshold: number = 0;
    archiveInProgress: boolean = false;
    restoreInProgress: boolean = false;
    logArchiveInProgress: boolean = false;
    logRestoreInProgress: boolean = false;
    umbMigrationInProgress: boolean = false;
    rokshDesktopVersion = '';
    rokshMobileVersion = '';
    rokshShopserviceUrl = '';
    backupUsersessionFilenames: any = [];
    backupLogTablesFilenames: any = [];
    logTableArchiveDescription: string = '';

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        private http: HttpClient,
        private _environmentServices: EnvironmentServices) {}

    ngOnInit() {
        this.rokshShopserviceUrl = this._environmentServices.getRokshShopserviceUrl();
        this._refreshRokshClientVersions();
    }

    public ArchiveUserSession() {
        if (this.userSessionIdThreshold < 1) return;

        this.modalRef.hide();
        this.archiveInProgress = true;

        this.siteServices.correction_Execute(
            'CORRECTION',
            'ARCHIVE_USERSESSION',
            this.userSessionIdThreshold,
            () => {
                this.siteServices.success('UserSession archive starting...');
                this.archiveInProgress = false;
            }
        );
    }

    public ArchiveUserSessionModal() {
        this.modalRef = this.modalService.show(this.archiveUserSessionTemplateRef, {
            class: 'modal-md',
        });
    }

    public RestoreUserSession(filename: string) {
        this.modalRef.hide();
        this.restoreInProgress = true;

        this.siteServices.correction_Execute(
            this.pid,
            'RESTORE_USERSESSION',
            filename,
            (data) => {
                this.siteServices.success('UserSession restore starting...');
                this.restoreInProgress = false;
            }
        );
    }

    public RestoreUserSessionModal() {
        this.siteServices.correction_Execute(
            this.pid,
            'GETUSERSESSIONBACKUPFILENAMES',
            '',
            (data) => {
                this.backupUsersessionFilenames = data.TagObject.Result;
                this.modalRef = this.modalService.show(this.restoreUserSessionTemplateRef, {
                    class: 'modal-md'
                });
            }
        );
    }

    public ArchiveLogTables() {
        this.modalRef.hide();
        this.logArchiveInProgress = true;

        this.siteServices.correction_Execute(
            'CORRECTION',
            'ARCHIVE_LOGTABLES',
            this.logTableArchiveDescription,
            () => {
                this.siteServices.success('Log tables archive starting...');
                this.logArchiveInProgress = false;
                this.backupLogTablesFilenames = '';
            }
        );
    }

    public ArchiveLogTablesModal() {
        this.modalRef = this.modalService.show(this.archiveLogTablesTemplateRef, {
            class: 'modal-md',
        });
    }

    public RestoreLogTables(filename: string) {
        this.modalRef.hide();
        this.logRestoreInProgress = true;

        this.siteServices.correction_Execute(
            this.pid,
            'RESTORE_LOGTABLES',
            filename,
            (data) => {
                this.siteServices.success('Log tables restore starting...');
                this.logRestoreInProgress = false;
            }
        );
    }

    public RestoreLogTablesModal() {
        this.siteServices.correction_Execute(
            this.pid,
            'GETLOGTABLESBACKUPFILENAMES',
            '',
            (data) => {
                this.backupLogTablesFilenames = data.TagObject;
                this.modalRef = this.modalService.show(this.restoreLogTablesTemplateRef, {
                    class: 'modal-md'
                });
            }
        );
    }

    public ElasticInit() {
        this.siteServices.correction_Execute(
            'CORRECTION',
            'ELASTICINIT',
            {},
            (data) => {
                this.siteServices.success('ElasticInit - OK');
            }
        );
    }


    public IncrementRokshDesktopVersion() {
        this.siteServices.correction_Execute(
            'CORRECTION',
            'INCREMENTDESKTOPVERSION',
            {},
            (data) => {
                this.siteServices.success('Incrementation - OK');
                this._refreshRokshClientVersions();
            }
        );
    }


    public IncrementRokshMobileVersion() {
        this.siteServices.correction_Execute(
            'CORRECTION',
            'INCREMENTMOBILEAPPVERSION',
            {},
            (data) => {
                this.siteServices.success('Incrementation - OK');
                this._refreshRokshClientVersions();
            }
        );
    }

    public UmbMigration() {
        if (this.counter < 1) return;
        this.umbMigrationInProgress = true;
        this.siteServices.correction_Execute_userid(
            this.pid,
            'UMBMIGRATION',
            {},
            () => {
                this.siteServices.success('UmbMigration - OK');
                this.umbMigrationInProgress = false;
            },
            this.counter,
            this.userId
        );

        this.modalRef.hide();
    }

    public UmbModal() {
        this.modalRef = this.modalService.show(this.umbmigrationTemplateRef, {
            class: 'modal-md',
        });
    }


    private _refreshRokshClientVersions() {
        this._getDesktopVersion()
            .subscribe((response) => {
                console.log(response);
                this.rokshDesktopVersion = JSON.stringify(response);
            });


        this._getMobileVersion()
            .subscribe((response) => this.rokshMobileVersion = JSON.stringify(response));
    }

    private _getDesktopVersion() {

        console.log('rokshShopserviceUrl', this.rokshShopserviceUrl);

        if (this.rokshShopserviceUrl.indexOf('staging') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberDesktopStaging');
        } else if (this.rokshShopserviceUrl.indexOf('master') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberDesktopMaster');
        } else if (this.rokshShopserviceUrl.indexOf('shopservce.roksh') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberDesktop');
        } else {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberDesktopStaging');
        }
    }


    private _getMobileVersion() {
        if (this.rokshShopserviceUrl.indexOf('staging') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberMobileStaging');
        } else if (this.rokshShopserviceUrl.indexOf('master') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberMobileMaster');
        } else if (this.rokshShopserviceUrl.indexOf('shopservice.roksh') > -1) {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberMobile');
        } else {
            return this.http.get<string>(this.rokshShopserviceUrl + '/mobileApplicationSettings/frontendVersionNumber/FrontendVersionNumberMobileStaging');
        }
    }

}
